<template>
  <label v-if="label" class="control-label">{{ label }}</label>
  <input class="form-control"
         :class="modClass"
         :disabled="disabledInternal"
         :required="required"
         v-model="value"
         @paste.prevent="pastePrevent"
         @paste="onPaste"
         :placeholder="placeholderInternal"
         ref="inputRef"         
         />
  <div class="invalid-msg" v-if="v$.value.$error">

      <template v-if="v$.value.maxLengthValidator.$invalid">Максимальная длина поля
          {{ v$.value.maxLengthValidator.$params.value }} символов.
      </template>
      <template v-if="v$.value.numberFixLengthValidator.$invalid">Длина поля
          {{ v$.value.numberFixLengthValidator.$params.value }} символов, только
          цифры
      </template>    
      <template v-if="v$.value.passportDepValidator.$invalid">Введите данные в
          формате XXX-XXX, где
          X-цифры
      </template>       
      <template v-if="v$.value.passportSerieValidator.$invalid">Длина поля 4 символа, только
          цифры
      </template>   
      <template v-if="v$.value.birthCertNumValidator.$invalid">Длина поля 6 символов, только
          цифры
      </template>   
      <template v-if="v$.value.passportNumValidator.$invalid">Длина поля 6 символов, только  цифры
      </template>   
      <template v-if="v$.value.required.$invalid">Поле обязательно для заполнения</template>
  </div>        
</template>

<script>
import Inputmask from 'inputmask';
import {helpers, requiredIf} from "@vuelidate/validators";
import {useVuelidate} from '@vuelidate/core'

const numberFixLengthValidator = (param) =>
    helpers.withParams(
        {type: 'numberFixLengthValidator', value: param},
        (value) => {
            if (param === 0 || !value || value.length === 0) return true;
            var re = new RegExp("^[0-9]{" + param + "}$");
            return re.test(value)
        }
    );

const maxLengthValidator = (param) =>
    helpers.withParams(
        {type: 'maxLengthValidator', value: param},
        (value) => {
            if (param === 0 || !value) return true;
            return (''+value).length <= param
        }
    );

const passportSerieValidator = (useValidation, fieldType) =>
    helpers.withParams(
        {type: 'passportSerieValidator'},
        (value) => {
          if (fieldType !=='passportSerie')
            return true;
          if (!useValidation)
            return true;
          if (!value || value.length === 0) return true;
          var re = new RegExp("^[0-9]{4}$");
          return re.test(value)
        }
    );

const passportNumValidator = (useValidation, fieldType) =>
    helpers.withParams(
        {type: 'passportNumValidator'},
        (value) => {
          if (fieldType !=='passportNum')
            return true;
          if (!useValidation)
            return true;
          if (!value || value.length === 0) return true;
          var re = new RegExp("^[0-9]{6}$");
          return re.test(value)
        }
    );

const birthCertNumValidator = (useValidation, fieldType) =>
    helpers.withParams(
        {type: 'birthCertNumValidator'},
        (value) => {
          if (fieldType !=='birthCertNum')
            return true;
          if (!useValidation)
            return true;
          if (!value || value.length === 0) return true;
          var re = new RegExp("^[0-9]{6}$");
          return re.test(value)
        }
    );

const passportDepValidator = (useValidation, fieldType) =>
    helpers.withParams(
        {type: 'passportDepValidator'},
        (value) => {
        if (fieldType !=='passportDep')
          return true;
        if (!useValidation)
          return true;
        if (!value || value.length === 0) return true;
        var re = new RegExp("^[0-9]{3}-[0-9]{3}$");
        return re.test(value);
        }
    );

const snilsValidator = (useValidation, fieldType) =>
    helpers.withParams(
        {type: 'snilsValidator'},
    (value) => {
    if (fieldType !=='snils')
      return true;
    if (!useValidation)
      return true;      
    if (!value || value.length === 0) return true;
    var re = new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{3} [0-9]{2}$");
    return re.test(value);
     }
);    


export default {
  name: 'ComponentInput',
  props: {
    disabled: {
      type: Boolean
    },
    modelValue: Object,
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: [String, Number],
      default: ''
    },
    modClass: {
      type: String,
      default: ''
    },
    inputMask: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      validator: function (value) {
        return ['phone', 'passportSerie', 'passportNum', 'birthCertNum', 'snils', 'passportDep', 'time'].indexOf(value) !== -1
      }
    },
    useDefaultValidation: {
      type: Boolean,
      default: true
    },
    maxLength: {
      type: Number,
      default: 0
    },
    fixLength: {
      type: Number,
      default: 0
    }
  }, 
  watch: {
            disabled: function (newValue) {
                this.disabledInternal = newValue;
            },
  },  
  emits: ['update:modelValue'],
  data() {
    return {
      placeholderInternal: this.placeholder,
      maskInternal: '',
      disabledInternal: this.disabled
    }
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set (value) {
        console.log(value, "--------- set");
        this.$emit('update:modelValue', value);
      }
    }
  },  
  mounted() {
    this.fillInputParams();
    var mask = this.maskInternal || this.inputMask;
    if (mask !== '') {
     var im = new Inputmask(mask);
     //im.mask($('.form-control'));
     im.mask($(this.$refs.inputRef));
    }
  },  
  setup: () => ({v$: useVuelidate()}),  
  validations() {
      return {
        value: { 
                    required: requiredIf(function () {
                        return this.required
                    }),
                    passportDepValidator: passportDepValidator(this.useDefaultValidation, this.type),
                    passportSerieValidator: passportSerieValidator(this.useDefaultValidation, this.type),
                    passportNumValidator: passportNumValidator(this.useDefaultValidation, this.type),
                    birthCertNumValidator: birthCertNumValidator(this.useDefaultValidation, this.type),
                    numberFixLengthValidator: numberFixLengthValidator(this.fixLength),
                    snilsValidator: snilsValidator(this.useDefaultValidation, this.type),
                    maxLengthValidator: maxLengthValidator(this.maxLength)
                }
    } 
  },
  methods: {
    fillInputParams(){
      if (this.type === 'phone') {
        this.placeholderInternal = '+7(___)___-__-__';
        this.maskInternal = '+7(999)999-99-99';
      }
      else if (this.type==='snils') {
        this.placeholderInternal = 'XXX-XXX-XXX XX';
        this.maskInternal = '999-999-999 99';
      }
      else if (this.type==='passportSerie') {
        this.placeholderInternal = 'XXXX';
        this.maskInternal = '9999';
      }
      else if (this.type==='passportNum') {
        this.placeholderInternal = 'XXXXXX';
        this.maskInternal = '999999';
      }
      else if (this.type==='birthCertNum') {
        this.placeholderInternal = 'XXXXXX';
        this.maskInternal = '999999';
      }
      else if (this.type==='passportDep') {
        this.placeholderInternal = 'XXX-XXX';
        this.maskInternal = '999-999';     
      } 
      else if (this.type==='time')
        this.maskInternal = '99:99';           
    },
    onPaste(evt) {
      this.$emit('update:modelValue', evt.clipboardData.getData('text'));

      this.$nextTick(() => {
        //console.log($(this.$refs.inputRef).val());
        if($(this.$refs.inputRef)[0].inputmask && $(this.$refs.inputRef).val() != evt.clipboardData.getData('text')) {
          var val = $(this.$refs.inputRef).val();
          this.value = $(this.$refs.inputRef).val();
          this.$nextTick(() => {
            this.value = val;
            $(this.$refs.inputRef).val(this.value);
          });
        }
      });

      return true;
    },
    pastePrevent(evt) {
      console.log(evt.clipboardData.getData('text'));
      return true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/theme/default/colors";
.form-check.required .control-label:after {
  content: "*";
  color: red;
}
.form-group.required .control-label:after {
  content: "*";
  color: red;
}
.invalid-msg {
  color: red;
  font-size: 0.75rem;
}

.form-control {
    max-width: 100%;
    background: $white;
    border: 1px solid $gray-light1;
    box-sizing: border-box;
    border-radius: 6px;
}
.control-label{
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
}
.form-check.required .control-label:after {
    content: "*";
    color: red;
}
.form-group.required .control-label:after {
    content: "*";
    color: red;
}
</style>